/**
 * Backend API base URL for proxy/backend requests.
 * - Development: leave REACT_APP_API_URL unset → '' so the dev server proxy handles /api/*
 * - Production: set REACT_APP_API_URL to your deployed backend (e.g. https://your-app.railway.app)
 */
export const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
